module.exports = __webpack_public_path__ + "static/media/Scarecrow.9f720a55.png";